import VisibilityIcon from '@mui/icons-material/Visibility'
import { Box, Paper, Typography } from '@mui/material'
import styled, { css } from 'styled-components'

export const Card = styled(Paper)(
  () => css`
    width: 100%;
    height: 100%;
    margin: 0 auto;
    align-self: center;
    justify-content: center;
  `
)

export const ContentBox = styled(Box)(
  ({ theme }) => css`
    width: 100%;
    padding: ${theme.layout.padding.base * 2}rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `
)

export const ContentInfo = styled('div')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.medium};
    align-items: center;
  `
)

export const Responsible = styled(Typography)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h7};
      font-weight: 700;
      line-height: 3.2rem;
      letter-spacing: 0.025rem;
      color: ${theme.colors.primary.main};
      @media (max-width: ${theme.screen.medium}) {
        display: none;
      }
    }
  `
)

export const Kinship = styled(Typography)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h7};
      font-weight: 700;
      line-height: 3.2rem;
      letter-spacing: 0.025rem;
      color: ${theme.colors.base.blue100};
    }
  `
)

export const NameResponsible = styled(Typography)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h7};
      font-weight: 200;
      line-height: 3.2rem;
      letter-spacing: 0.025rem;
      color: ${theme.colors.base.blue100};
      @media (max-width: ${theme.screen.medium}) {
        display: none;
      }
    }
  `
)

export const View = styled(VisibilityIcon)(
  ({ theme }) => css`
    font-size: ${theme.layout.iconSize.big};
    width: ${theme.layout.iconSize.big};
    height: ${theme.layout.iconSize.big};
    color: ${theme.colors.primary.main};
  `
)

export const ViewContainer = styled('div')(
  () => css`
    cursor: pointer;
  `
)
